import { render, staticRenderFns } from "./DrawerProjectDetail.vue?vue&type=template&id=0ff3233e&scoped=true&"
import script from "./DrawerProjectDetail.vue?vue&type=script&lang=js&"
export * from "./DrawerProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./DrawerProjectDetail.vue?vue&type=style&index=0&id=0ff3233e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff3233e",
  null
  
)

export default component.exports